"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7640],{

/***/ 27640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SC": function() { return /* binding */ apiFetch; },
  "h_": function() { return /* binding */ useApi; },
  "GH": function() { return /* binding */ useGetApiData; }
});

// UNUSED EXPORTS: AuthError, apiRequest

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_wrap_native_super.mjs + 2 modules
var _wrap_native_super = __webpack_require__(25892);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(76166);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(87066);
// EXTERNAL MODULE: ./hooks/useCookies.ts
var useCookies = __webpack_require__(63354);
// EXTERNAL MODULE: ./utils/consts.ts
var consts = __webpack_require__(69929);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./api/auth.js




var axiosInstance = axios/* default.create */.Z.create({
    baseURL: consts/* BASE_URL */._n
});
// Handle global logout
var logout = function() {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    // Force redirect to login page
    window.location.href = "/login";
};
axiosInstance.interceptors.request.use(function(config) {
    var accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        config.headers["Authorization"] = "Bearer ".concat(accessToken);
    }
    return config;
}, function(error) {
    return Promise.reject(error);
});
axiosInstance.interceptors.response.use(function(response) {
    return response;
}, function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(error) {
        var originalRequest, refreshToken, response, _data, accessToken, newRefreshToken, refreshError;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    originalRequest = error.config;
                    if (!(error.response.status === 401 && !originalRequest._retry)) return [
                        3,
                        4
                    ];
                    originalRequest._retry = true;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    refreshToken = localStorage.getItem("refreshToken");
                    return [
                        4,
                        axiosInstance.post("/refresh-token", {
                            refreshToken: refreshToken
                        })
                    ];
                case 2:
                    response = _state.sent();
                    _data = response.data, accessToken = _data.accessToken, newRefreshToken = _data.refreshToken;
                    localStorage.setItem("accessToken", accessToken);
                    if (newRefreshToken) {
                        localStorage.setItem("refreshToken", newRefreshToken);
                    }
                    axiosInstance.defaults.headers["Authorization"] = "Bearer ".concat(accessToken);
                    originalRequest.headers["Authorization"] = "Bearer ".concat(accessToken);
                    return [
                        2,
                        axiosInstance(originalRequest)
                    ];
                case 3:
                    refreshError = _state.sent();
                    logout();
                    return [
                        2,
                        Promise.reject(refreshError)
                    ];
                case 4:
                    return [
                        2,
                        Promise.reject(error)
                    ];
            }
        });
    });
    return function(error) {
        return _ref.apply(this, arguments);
    };
}());
/* harmony default export */ var auth = ((/* unused pure expression or super */ null && (axiosInstance)));

;// CONCATENATED MODULE: ./api/api.ts














var api = axios/* default.create */.Z.create({
    baseURL: consts/* BASE_URL */._n,
    headers: {
        "Content-Type": "application/json"
    }
});
// Error class to specifically handle auth errors
var AuthError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0,_inherits/* default */.Z)(AuthError, Error1);
    var _super = (0,_create_super/* default */.Z)(AuthError);
    function AuthError(message, status) {
        (0,_class_call_check/* default */.Z)(this, AuthError);
        var _this;
        _this = _super.call(this, message);
        _this.status = status;
        _this.name = "AuthError";
        return _this;
    }
    return AuthError;
}((0,_wrap_native_super/* default */.Z)(Error));
function apiRequest(url, axiosOptions) {
    return api.request(_object_spread({
        url: url
    }, axiosOptions));
}
function getTokenExpirationTime(token) {
    var payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000 - Date.now();
}
function verifyAccessToken(token) {
    return _verifyAccessToken.apply(this, arguments);
}
function _verifyAccessToken() {
    _verifyAccessToken = (0,_async_to_generator/* default */.Z)(function(token) {
        var error, ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios/* default.post */.Z.post("".concat(consts/* BASE_URL_AUTH */.Gd, "/auth/verify"), {
                            token: token
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        {
                            isValid: true
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.log((ref = error.response) === null || ref === void 0 ? void 0 : ref.status);
                    localStorage.removeItem("accessToken");
                    localStorage.removeItem("refreshToken");
                    if (error.response) {
                        return [
                            2,
                            {
                                isValid: false,
                                status: error.response.status
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            isValid: false
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _verifyAccessToken.apply(this, arguments);
}
function refreshAccessToken(refreshToken) {
    return _refreshAccessToken.apply(this, arguments);
}
function _refreshAccessToken() {
    _refreshAccessToken = (0,_async_to_generator/* default */.Z)(function(refreshToken) {
        var response, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios/* default.post */.Z.post("".concat(consts/* BASE_URL_AUTH */.Gd, "/auth/refresh"), {
                            token: refreshToken
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data.accessToken
                    ];
                case 2:
                    error = _state.sent();
                    throw new AuthError("Failed to refresh token", 401);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _refreshAccessToken.apply(this, arguments);
}
function useApi(url) {
    return _useApi.apply(this, arguments);
}
function _useApi() {
    _useApi = (0,_async_to_generator/* default */.Z)(function(url) {
        var authorizationType, axiosOptions, ref, get, set, token, refreshTokenValue, verification, newToken, error, headers, response, error1, ref1, ref2, ref3, err;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authorizationType = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "no-auth", axiosOptions = _arguments.length > 2 ? _arguments[2] : void 0;
                    ref = (0,useCookies/* default */.Z)(), get = ref.get, set = ref.set;
                    token = get("accessToken");
                    refreshTokenValue = get("refreshToken");
                    if (!(authorizationType === "jwt-auth")) return [
                        3,
                        7
                    ];
                    if (!token) {
                        logout();
                        throw new AuthError("No access token available", 401);
                    }
                    return [
                        4,
                        verifyAccessToken(token)
                    ];
                case 1:
                    verification = _state.sent();
                    if (!!verification.isValid) return [
                        3,
                        7
                    ];
                    // If unauthorized (401), immediately log out and throw auth error
                    if (verification.status === 401) {
                        logout();
                        throw new AuthError("Unauthorized: Session expired", 401);
                    }
                    if (!refreshTokenValue) return [
                        3,
                        6
                    ];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        refreshAccessToken(refreshTokenValue)
                    ];
                case 3:
                    newToken = _state.sent();
                    set("accessToken", newToken, 60 * 24 * 7);
                    token = newToken;
                    return [
                        3,
                        5
                    ];
                case 4:
                    error = _state.sent();
                    logout();
                    throw new AuthError("Session expired, please log in again", 401);
                case 5:
                    return [
                        3,
                        7
                    ];
                case 6:
                    logout();
                    throw new AuthError("No refresh token available", 401);
                case 7:
                    _state.trys.push([
                        7,
                        9,
                        ,
                        10
                    ]);
                    headers = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, axiosOptions === null || axiosOptions === void 0 ? void 0 : axiosOptions.headers), {
                        Authorization: token && authorizationType === "jwt-auth" ? "Bearer ".concat(token) : undefined,
                        "Content-Type": "application/json"
                    });
                    console.log("\uD83C\uDF10 ======= useApi: ENVIANDO REQUEST =======");
                    console.log("\uD83D\uDD17 URL:", url);
                    console.log("\uD83D\uDCCB Method:", (axiosOptions === null || axiosOptions === void 0 ? void 0 : axiosOptions.method) || "GET");
                    console.log("\uD83D\uDD11 Auth Type:", authorizationType);
                    console.log("\uD83D\uDCE6 Headers:", headers);
                    console.log("\uD83D\uDCE4 Request Data:", axiosOptions === null || axiosOptions === void 0 ? void 0 : axiosOptions.data);
                    if (axiosOptions === null || axiosOptions === void 0 ? void 0 : axiosOptions.data) {
                        try {
                            console.log("\uD83D\uDCE4 Request Data (parsed):", JSON.parse(axiosOptions.data));
                        } catch (e) {
                            console.log("\uD83D\uDCE4 Request Data (raw):", axiosOptions.data);
                        }
                    }
                    return [
                        4,
                        (0,axios/* default */.Z)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            url: url,
                            method: (axiosOptions === null || axiosOptions === void 0 ? void 0 : axiosOptions.method) || "GET"
                        }, axiosOptions), {
                            headers: headers
                        }))
                    ];
                case 8:
                    response = _state.sent();
                    console.log("✅ useApi: RESPUESTA RECIBIDA");
                    console.log("   Status:", response.status);
                    console.log("   Data:", response.data);
                    console.log("\uD83C\uDF10 ======= useApi: REQUEST COMPLETADO =======");
                    return [
                        2,
                        response.data
                    ];
                case 9:
                    error1 = _state.sent();
                    console.error("❌ useApi: ERROR EN REQUEST");
                    console.error("   URL:", url);
                    console.error("   Error:", error1);
                    console.error("   Response:", error1.response);
                    // 404 errors may be expected (e.g., no diagnoses found)
                    // Pass them through with more context
                    if (((ref1 = error1.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 404) {
                        ;
                        console.warn("API 404 Not Found: ".concat(url));
                        err = new Error();
                        err.message = ((ref2 = error1.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message) || "Resource not found";
                        err.response = error1.response;
                        throw err;
                    }
                    console.log("API call error:", error1);
                    // Check if this is an auth error from the API
                    if (error1.response && error1.response.status === 401) {
                        logout();
                        throw new AuthError("Unauthorized request", 401);
                    }
                    throw error1;
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
    return _useApi.apply(this, arguments);
}

function fetchApiData(url, options, setData, setError, setLoading, onAuthError) {
    return _fetchApiData.apply(this, arguments);
}
function _fetchApiData() {
    _fetchApiData = (0,_async_to_generator/* default */.Z)(function(url, options, setData, setError, setLoading, onAuthError) {
        var response, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    setLoading(true);
                    return [
                        4,
                        useApi(url, "jwt-auth", {
                            method: options.method || "GET",
                            headers: (0,src_object_spread/* default */.Z)({
                                "Content-Type": "application/json"
                            }, options.headers),
                            data: options.body
                        })
                    ];
                case 1:
                    response = _state.sent();
                    setError(null);
                    setData(response);
                    setLoading(false);
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    if ((0,_instanceof/* default */.Z)(err, AuthError) && err.status === 401 && onAuthError) {
                        onAuthError();
                    }
                    setError(err);
                    setLoading(false);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _fetchApiData.apply(this, arguments);
}
function useGetApiData(url) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, onAuthError = arguments.length > 2 ? arguments[2] : void 0;
    var ref = (0,react.useState)(null), data = ref[0], setData = ref[1];
    var ref1 = (0,react.useState)(true), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(null), error = ref2[0], setError = ref2[1];
    var fetchData = function() {
        // Si la URL es vacía o inválida, no hacer la llamada API
        if (!url || url.trim() === "") {
            setLoading(false);
            setData(null);
            setError(null);
            return;
        }
        fetchApiData(url, options, setData, setError, setLoading, onAuthError);
    };
    (0,react.useEffect)(function() {
        fetchData();
    }, [
        url
    ]);
    return {
        data: data,
        loading: loading,
        error: error,
        refetch: fetchData
    };
}
var apiFetch = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(url, method, data, onAuthError) {
        var options, response, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = {
                        method: method,
                        headers: {
                            "Content-Type": "application/json"
                        },
                        data: method === "POST" || method === "PUT" || method === "PATCH" ? data : undefined
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        useApi(url, "jwt-auth", options)
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        {
                            response: response,
                            error: null
                        }
                    ];
                case 3:
                    error = _state.sent();
                    console.log("Error fetching data:", error);
                    if ((0,_instanceof/* default */.Z)(error, AuthError) && error.status === 401 && onAuthError) {
                        onAuthError();
                    }
                    return [
                        2,
                        {
                            response: null,
                            error: error
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function apiFetch(url, method, data, onAuthError) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);